import PropTypes from 'prop-types';

export default {
    formLoading: PropTypes.bool.isRequired,
    formGroupError: PropTypes.string,
    socialAuthError: PropTypes.string,
    emailError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    showFacebookEmailModal: PropTypes.bool.isRequired,
    socialAuthLoading: PropTypes.bool.isRequired,
    onToggleRegisterClick: PropTypes.func.isRequired,
    onFacebookClick: PropTypes.func.isRequired,
    onGoogleClick: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onUserFieldChange: PropTypes.func.isRequired,
    onFacebookEmailModalHidden: PropTypes.func.isRequired,
    register: PropTypes.bool,
    recaptchaError: PropTypes.bool,
};
